module.exports = __webpack_public_path__ + "static/media/test.6615aa33.svg";